import "./v1/EnergyLabelV1.svelte";
import type {Component} from "./v1/EnergyLabelV1.types";

/*                  */
try {
  let EnergyLabel = customElements.get("ofc-energy-label-v1" as Component);
  if (EnergyLabel) {
    customElements.define("oc-energy-label-v1", class extends EnergyLabel {
    });
  }
} catch (error) {
}
